// Lib
import React from 'react';

// Components
import Button from '../../../Button';
import Feather from '../../../Feather';
import Track from '../../../OrderHistory/Buttons/Track';

// Hooks
import useUser from '../../../../hooks/useUser';

// Styles
import { useStyles } from './ShippingCardStyles';

const ShippingCard = ({
  title,
  className,
  children,
  onChange,
  multipleMode = false,
  isOrderPlaced = false,
  onDeleteAddress = () => {},
  trackingLink,
  withControls = true,
  dataTestId,
  dataTestIdForCard = '',
}) => {
  const { isKiteUser } = useUser();
  const { classes, cx } = useStyles({
    multipleMode,
    isKiteUser,
    isOrderPlaced,
  });

  return (
    <>
      {!isOrderPlaced ? (
        <div
          data-testid={dataTestIdForCard}
          className={cx(classes.root, className)}>
          {multipleMode && withControls && (
            <Button
              variant="text"
              onClick={onDeleteAddress}
              className={classes.deleteButton}
              data-testid="delete-address-button">
              <Feather type="delete" />
            </Button>
          )}
          <div className={classes.fullWidth}>
            <div className={classes.title} data-testid={dataTestId}>
              {title}
            </div>
            {children}
          </div>
          {!multipleMode && withControls && (
            <Button
              onClick={onChange}
              variant="text"
              className={classes.button}
              data-testid="change-button">
              Change <Feather printType="stroke" type="arrowRight" />
            </Button>
          )}
        </div>
      ) : (
        <div className={cx(classes.container, className)}>
          <div className={classes.title} data-testid={dataTestId}>
            {title}
          </div>
          {children}
          {trackingLink && (
            <Track
              trackingLink={trackingLink}
              className={classes.trackButton}
            />
          )}
        </div>
      )}
    </>
  );
};

export default ShippingCard;
